import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.5 7.388a.996.996 0 00-1.41 0l-4.59 4.59a.996.996 0 000 1.41l4.59 4.59a.996.996 0 101.41-1.41l-3.88-3.89 3.88-3.88c.39-.39.38-1.03 0-1.41z" fill="#07A" /></svg>;